const showConsole =
  process.env.NODE_ENV === 'development' ||
  window.location.search.includes('version=dev');

export default showConsole;